import { FC } from "react";
import { HStack, Stack, Text } from "@chakra-ui/react";
import { useVariant } from "@unleash/proxy-client-react";

import { ICard } from "../../../../../../api/cards/types.ts";
import { UnleashFlags } from "../../../../../../constants";
import { formatPriceWithoutZeros, isStringWithNumber } from "../../../../../../utils";

interface Props {
  paymentAmount: number;
  commissionAmount: number;
  paymentMethod: ICard;
}

export const PaymentModalDetails: FC<Props> = (props) => {
  const {
    paymentAmount,
    commissionAmount,
    paymentMethod,
  } = props;

  const paymentAmountText = formatPriceWithoutZeros(paymentAmount);
  const commissionAmountText = formatPriceWithoutZeros(commissionAmount);

  const commissionVariant = useVariant(UnleashFlags.dfPaymentsCommission);
  const commissionValue = commissionVariant.payload?.value;
  const commissionText = paymentMethod.terminalType === "PAID" && isStringWithNumber(commissionValue)
    ? `Комиссия ${commissionValue}%`
    : "Комиссия";

  return (
    <Stack spacing="2px" mb="28px">
      <HStack justifyContent="space-between">
        <Text fontSize="14px">Платёж по договору</Text>
        <Text fontSize="14px" variant="brand">{paymentAmountText}</Text>
      </HStack>

      <HStack justifyContent="space-between">
        <Text fontSize="14px">{commissionText}</Text>
        <Text fontSize="14px" variant="brand">{commissionAmountText}</Text>
      </HStack>
    </Stack>
  );
};
